import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { BACKEND_URL } from "../common/Common";
import useEmirateFromCoordinates from "../common/Common";
import axios from "axios";
import { useLocation } from "../../contexts/LocationContext";
import "../categorylist/CategoryList.css"
import "../nearyou/NearYou.css"
//Navbar and Left Section Images
import search from '../../assets/home-images/search.png';
import downarrow from '../../assets/home-images/downarrow.png';
import leftarrow from '../../assets/offers/leftarrow.png';
import flagicon from '../../assets/home-images/flagicon.png';
import businessicon from '../../assets/home-images/businessicon.jpg';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import nodata from '../../assets/experience/nodata.png';
import Navbar from "../common-component/navbar/Navbar";
import expbanner from '../../assets/experience/Expbanner.png';

// Helper function to calculate discount text - memoized outside component
const getDiscountText = (item, className = "offer-tag") => {
    switch (item.discount_type_id) {
        case 8:
        case 4:
            return <span className={className}>{item.discount_type}</span>;
        case 7:
            return (
                <span className={className}>
                    {item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}
                </span>
            );
        case 5:
            return (
                <span className={className}>
                    Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                </span>
            );
        case 1:
            return item.discount_value && item.discount_price && item.coupon_price ? (
                <>
                    <span className="old-price">AED {item.coupon_price}</span>
                    <span className="new-price">AED {item.discount_price}</span>
                    <span className="separator">|</span>
                    <span className={className}>{item.discount_value}% OFF</span>
                </>
            ) : (
                <span className={className}>AED {item.coupon_price}</span>
            );
        case 10:
            return className === "limited-deals-tag" ? (
                <span className={className}>From AED {item.coupon_price}</span>
            ) : (
                <span className="discount_type_from">
                    From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                </span>
            );
        default:
            return item.discount_type === "Total" ? (
                <span className={className}>{item.discount_value}% OFF</span>
            ) : (
                <span className={className}>{item.discount_type}</span>
            );
    }
};

const NearYou = () => {
    const navigate = useNavigate();
    // Use LocationContext for global location management
    const { latitude, longitude, selectedState, updateLocation, isLocationLoading, hasRealLocation } = useLocation();
    const emirate = useEmirateFromCoordinates(latitude, longitude);

    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]);
    const [nearme, setNearMe] = useState([]);
    const [isNearMeLoading, setIsNearMeLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // Scroll to top on mount (fixes mobile scroll position issue)
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);

    // LocationContext handles all location initialization, no need for local useEffect

    // Handle location change from country popup - use global context
    const handleStateChange = useCallback((state) => {
        console.log("🟢 [NearYou] Location Selected:", state.name);
        updateLocation(state); // Updates global LocationContext
        setCountrypopup(false);
    }, [updateLocation]);

    // Fetch master data for states
    const fetchMasterData = async () => {
        try {
            const response = await axios.get(`${BACKEND_URL}website/get-master-data`);
            if (response.data.stateData) {
                setStates(response.data.stateData);
            } else {
                setStates([]);
            }
        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };

    // Fetch near me data
    const fetchNearMeList = useCallback(async (search = "") => {
        // Wait for location to be ready
        if (isLocationLoading || !latitude || !longitude) {
            console.log('[NearYou] ⏳ Waiting for location...', { latitude, longitude, isLocationLoading });
            return;
        }

        console.log('[NearYou] 📡 Making API call with coordinates:', { latitude, longitude, isReal: hasRealLocation });

        setIsNearMeLoading(true);

        const payload = {
            latitude: latitude,
            longitude: longitude,
            near_me: true,
            login_user_id: 501,
            search: search.trim() || "",

        };

        try {
            const response = await axios.post(
                `${BACKEND_URL}website/get-coupon-list?_t=${Date.now()}`,
                payload,
                {
                    timeout: 10000,
                    withCredentials: false,
                    headers: {
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                    },
                }
            );

            const data = response.data?.data || response.data || [];
            setNearMe(Array.isArray(data) ? data : []);

        } catch (error) {
            console.error("❌ Error fetching Near Me list:", error);
            setNearMe([]);
        } finally {
            setIsNearMeLoading(false);
        }
    }, [latitude, longitude, isLocationLoading, hasRealLocation]);

    // Initial data fetch
    useEffect(() => {
        fetchMasterData();
    }, []);

    // Fetch near me data when location changes
    useEffect(() => {
        if (isLocationLoading || !latitude || !longitude) {
            console.log('[NearYou] ⏳ Waiting for location before fetching...');
            return;
        }
        fetchNearMeList(searchTerm);
    }, [latitude, longitude, isLocationLoading, hasRealLocation, fetchNearMeList, searchTerm]);

    // Debounced search effect - only triggers when searchTerm changes
    useEffect(() => {
        if (isLocationLoading || !latitude || !longitude) return;

        // Debounce the API call
        const timeoutId = setTimeout(() => {
            setIsNearMeLoading(true);
            fetchNearMeList(searchTerm);
        }, 500); // 500ms debounce delay

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm, latitude, longitude, isLocationLoading]);

    // Get display list (filtered by search if needed)
    const getDisplayNearMeList = useMemo(() => {
        if (!Array.isArray(nearme)) return [];
        return nearme;
    }, [nearme]);

    const handleSearchChange = useCallback((e) => {
        setSearchTerm(e.target.value);
    }, []);

    return (
        <div>
            <Navbar
                selectedState={selectedState}
                onStateChange={handleStateChange}
                states={states}
                showLocationSelector={true}
            />

            {/* Mobile Header - Below Navbar */}
            <div className="mobile-category-header">
                <div className="mobile-header-top">
                    <div className="mobile-category-title">
                        <img src={leftarrow} alt="back" className="mobile-back-icon" onClick={() => navigate(-1)} />
                        <h4>Near You</h4>
                    </div>
                </div>
                <div className="mobile-search-filter-container">
                    <div className="mobile-searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search offers..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>
            </div>

            <div className="experience-main-layout category-list-page-main-layout">
                <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="left-menu-content">
                        <div className="img-contentname" onClick={() => setCountrypopup(true)}>
                            <img src={flagicon} alt="flag" className="flagicon" />
                            <p>{selectedState?.name || emirate?.name || "Abu Dhabi"}</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="left-bottom-links">
                        <div className="left-bottom1">
                            <a href="/about">About Us</a>
                            {/* <a href="#BusinessPro">Business Pro</a> */}
                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                            <a href="/businesspro">Business Pro</a>
                            <a href="/downloadpage">Download</a>
                        </div>
                    </div>
                </aside>

                <main className="experience-middle-section">
                    <div className="mid-section-head-div">
                        <img src={expbanner} alt="enjoy summer" className="enjoy-summer-img" />
                    </div>

                    <div className="category-title catgeory-list-page">
                        <h6>
                            <Link to="/experience" className="remove-underline">
                                <span>Experience /</span>
                            </Link>
                            {' '}Near You
                        </h6>
                        {/* <p>{getDisplayNearMeList.length} offers</p> */}
                    </div>

                    <div className="offers-grid-container category-list-page">
                        {isNearMeLoading ? (
                            // Shimmer loading skeleton
                            Array.from({ length: 6 }).map((_, index) => (
                                <div key={`shimmer-${index}`} className="offer-card-grid shimmer-card">
                                    <div className="offer-img-wrapper-grid shimmer-image"></div>
                                    <div className="offer-details-grid">
                                        <div className="shimmer-line shimmer-location"></div>
                                        <div className="shimmer-line shimmer-title"></div>
                                        <div className="shimmer-line shimmer-subtitle"></div>
                                        <div className="shimmer-line shimmer-price"></div>
                                    </div>
                                </div>
                            ))
                        ) : getDisplayNearMeList.length > 0 ? (
                            getDisplayNearMeList.map((item, index) => {
                                if (!item) return null;

                                // Safety check for category
                                const categoryId = item.category && Array.isArray(item.category) && item.category.length > 0
                                    ? item.category[0]?.category
                                    : null;

                                if (!categoryId || !item.coupon_id) return null;

                                return (
                                    <Link
                                        to={`/offers/${item.coupon_id}/${categoryId}`}
                                        className="remove-underline"
                                        key={`${item.coupon_id}-${index}`}
                                    >
                                        <div className="offer-card-grid">
                                            <div className="offer-img-wrapper-grid categorylistpage">
                                                <img
                                                    src={item.coupon_image || ""}
                                                    alt={item.coupon_title || "Offer"}
                                                    loading="lazy"
                                                    onError={(e) => {
                                                        e.target.src = "/no-image.png";
                                                    }}
                                                />
                                            </div>

                                            <div className="offer-details-grid">
                                                <p className="offer-location">
                                                    <span>
                                                        <img src={businessicon} alt="logo" className="bussinessicon" />
                                                    </span>
                                                    <span>{item.user_name || "N/A"}</span>
                                                </p>

                                                <h4>{item.coupon_title || "Untitled Offer"}</h4>

                                                <p className="limited-deals-distance">
                                                    {item.distance ? Math.round(item.distance) : 0} km | {item.location || "N/A"}
                                                </p>

                                                <div className="offer-prices">{getDiscountText(item)}</div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })
                        ) : (
                            <div className="nodata-message-categorylist">
                                <img src={nodata} alt="no data" className="no-data-img" />
                                <p className="no-data-p1">No offers found</p>
                                <p className="no-data-p2">Try adjusting your search</p>
                            </div>
                        )}
                    </div>
                </main>

                {/* Country pop up */}
                {countrypopup && (
                    <>
                        {/* Overlay */}
                        <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>

                        {/* Centered Popup */}
                        <div className="custom-popup">
                            <div className="custom-popup-header">
                                <h4>Choose Your Location</h4>
                                <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                            </div>

                            {/* States List */}
                            <div className="custom-popup-body">
                                <div className="state-grid">
                                    {states.filter((state) => Number(state.country_id))
                                        .map((state, index, arr) => {
                                            const isDisabled = index >= arr.length - 4; // last 4 items

                                            return (
                                                <div
                                                    key={state.id}
                                                    className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                    onClick={() => !isDisabled && handleStateChange(state)}
                                                >
                                                    <img
                                                        src={flagicon}
                                                        alt="flag"
                                                        className="flagicon-popup"
                                                    />
                                                    <p>{state.name}</p>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default NearYou;
